<template>
  <div id="login">
    <h2>ログイン</h2>
    <hr>
    <div v-show="result">
      <div v-show="!success">
        <p class="has-text-danger">{{ errMsg }}</p>
      </div>
    </div>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="!loading && main">
      <section>
        <b-field horizontal label="メールアドレス">
          <b-input v-model.trim="email" type="email" maxlength="50"></b-input>
        </b-field>
        <b-field horizontal label="パスワード">
          <b-input v-model.trim="password" type="password" password-reveal></b-input>
        </b-field>
        <button class="button is-primary" v-on:click="exec()">ログイン</button>
        <br>
        <br>
        <router-link to="/reset">パスワードを忘れた方</router-link> |
        <router-link to="/signup">ユーザー作成はこちら</router-link>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      email: '',
      password: '',
      errMsg: ''
    }
  },
  methods: {
    exec: function () {
      this.main = false
      this.loading = true

      this.$axios.post(this.baseURL + '/login', {
        email: this.email,
        password: this.password
      }, {
        withCredentials: true
      }).then(response => {
        this.loading = false
        this.result = true
        this.success = true
        this.$store.commit('setLogin',
          {email: response.data.email, isLoggedIn: true, isPremium: response.data.is_premium})
        this.$router.push('/')
      }).catch((response) => {
        if (response.response.data === 'bind_json') {
          this.errMsg = '内部のエラーで登録できませんでした...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'hash') {
          this.errMsg = 'パスワードの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'encrypt') {
          this.errMsg = 'メールアドレスの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'ng') {
          this.errMsg = 'ログインに失敗しました...🙏 メールアドレスかパスワードを再度確認してください。'
        }
        if (response.response.data === 'is_premium') {
          this.errMsg = 'ログインに失敗しました...🙏 あなたがプレミアムユーザーかどうか取得することに失敗しました。解決までしばらくお待ち下さい。'
        }
        this.loading = false
        this.main = false
        this.result = true
        this.success = false
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue